module.exports = __webpack_public_path__ + "img/Stage_8.3ef1fa5b.svg";